module.exports = __webpack_public_path__ + "img/wide.cd4336d1.jpg";